import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "./home.scss";
import axios from "axios";
import Form from "./Form";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { Alert, Button, Modal } from "@mui/material";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import Drawer from "@mui/material/Drawer";
import CloseIcon from "@mui/icons-material/Close";
import { useOrder } from "../../../context/OrderContext";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import Tickets from "./Tickets";
import Testimonials from "./Testimonials";
import ReactPlayer from "react-player";
import people from "../../images/people.webp";
import attendeesSq from "../../images/attendees2.webp";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import speakers from "../../images/speaker.webp";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SpeakersHP from "./SpeakersHP";
import FAQ from "../FAQ/FAQ";
import coneimg from "../../images/cone.png";
import DiscountWheel from "../Discount/DiscountWheel";
import ExitModal from "../Discount/ExitModal";
import Sat from "../../images/sponsors/satinder.webp";
import Moah from "../../images/sponsors/moah.webp";
import pmw from "../../images/sponsors/pmw.webp";
import det from "../../images/sponsors/detailing.png";

export default function NewHome() {
  const navigate = useNavigate();
  const { order, addToOrder, removeFromOrder, qtyAlert } = useOrder();
  const url = "https://dev.pmwevents.com";
  const [tickets, setTickets] = useState([]);
  const [liveEvent, setLiveEvent] = useState(false);
  const [openCartDrawer, setOpenCartDrawer] = useState(false);
  const playerRef = useRef(null);
  const containerRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [cone, setCone] = useState([]);
  const [openDiscountModal, setOpenDiscountModal] = useState(false);
  const [openExitModal, setOpenExitModal] = useState(false);
  const [exitCheck, setExitCheck] = useState(false);

  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const target = document.getElementById(location.state.scrollTo);
      if (target) {
        // Delay scroll to ensure DOM is rendered
        setTimeout(() => {
          target.scrollIntoView({ behavior: "smooth" });
        }, 500);
      }
    }
  }, [location]);

  //VIDEO WILL AUTOPLAY ON SCROLL OF PAG‰
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsPlaying(true);
        } else {
          setIsPlaying(false);
        }
      },
      {
        threshold: 0.1, // play when 30% of the element is visible
      }
    );

    observer.observe(container);

    return () => {
      if (container) observer.unobserve(container);
    };
  }, []);

  //THIS USEEFFECT WILL TRIGGER THE GET EVENT TICKETS
  useEffect(() => {
    let id = localStorage.getItem("sbcTicket");

    axios
      .get(`${url}/sbc/get-active-sbc`)
      .then((res) => {
        setLiveEvent(true);
        getEvent(res.data[0].eventId);
      })
      .catch((err) => {
        console.log("Could not get active SBC events");
      });
  }, []);

  //THIS USEEFFECT WILL CLOSE THE SIDE DRAWER CART IF NO TICKETS
  useEffect(() => {
    if (order.length === 0) {
      setOpenCartDrawer(false);
    }
  }, [order]);

  //USE EFFECT FOR TRIGGERING AN EXIT MODAL IF THE USER TRIES TO LEAVE PAGE
  // useEffect(() => {
  //   if (exitCheck) return;

  //   const handleMouseLeave = (e) => {
  //     // e.clientY <= 0 means mouse left viewport from the top
  //     if (e.clientY <= 0) {
  //       setOpenExitModal(true);
  //       setExitCheck(true);
  //     }
  //   };

  //   document.addEventListener("mouseleave", handleMouseLeave);

  //   return () => {
  //     document.removeEventListener("mouseleave", handleMouseLeave);
  //   };
  // }, [exitCheck]);

  //THIS GETS TICKETS FOR A SPECIFIC EVENT
  const getEvent = async (id) => {
    localStorage.setItem("eventId", id);
    const eventId = {
      event: id,
    };
    await axios
      .post(`${url}/sbc/get-sbc-not-all`, eventId)
      .then((res) => {
        setTickets(res.data);
      })
      .catch((err) => {
        console.log(err);
        console.log("Could not get details of SBC Event");
      });
  };

  const scrollTo = () => {
    document.getElementById("tickets").scrollIntoView();
  };

  const handleCone = (coneId, domId) => {
    let cones = [...cone];

    let coneIndex = cones.findIndex((c) => c === coneId);

    if (coneIndex < 0) {
      cones.push(coneId);
      const el = document.getElementById(domId);
      if (el) {
        // remove existing class (if still there) so we can retrigger animation
        el.classList.remove("shake");
        void el.offsetWidth; // <- force reflow (important trick!)
        el.classList.add("shake");

        // clean up after animation
        el.addEventListener(
          "animationend",
          () => {
            el.classList.remove("shake");
          },
          { once: true }
        );
      }
    } else {
      console.log("already found");
    }

    if (cones.length < 4) {
      setCone(cones);
    } else {
      setOpenDiscountModal(true);
    }
  };

  //THIS COMPONENT IS THE CART DRAWER
  const DrawerList = (
    <Box sx={{ width: 360 }} role="presentation">
      <section className="home-cart-drawer">
        <div className="home-cart-content">
          <CloseIcon
            className="cart-drawer-close"
            onClick={() => setOpenCartDrawer(false)}
          />
          <h5>Your Cart</h5>
          <hr />
          <table className="drawer-cart-table">
            <thead>
              <tr>
                <th>Product</th>
                <th className="total-cell">Total</th>
              </tr>
            </thead>
            <tbody>
              {order.map((o, i) => {
                return (
                  <tr key={i}>
                    <td>
                      <p className="ticket-type-name"> {o.name}</p>
                      <p className="price">£{o.price.toFixed(2)} + VAT</p>

                      <div class="cart-quantity-container">
                        <button
                          class="qty-btn dec"
                          onClick={() => removeFromOrder(o)}
                        >
                          <RemoveIcon />
                        </button>
                        <span class="qty-display">{o.qty}</span>
                        <button
                          class="qty-btn inc"
                          onClick={() => addToOrder(o)}
                          disabled={o.qty === 4}
                        >
                          <AddIcon />
                        </button>
                      </div>
                    </td>
                    <td className="total-cell">
                      £{o.total.toFixed(2)} + <span>VAT</span>
                    </td>
                    {qtyAlert != "" ? (
                      <Alert
                        severity="warning"
                        style={{
                          position: "absolute",
                          top: "30%",
                          left: "0",
                          width: "100%",
                        }}
                      >
                        No more {o.name} tickets available{" "}
                      </Alert>
                    ) : null}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="cart-bottom-section">
          <hr />
          <h5>
            Estimated total
            <span>
              £{order.reduce((a, b) => a + b.total, 0).toFixed(2)} + VAT
            </span>
          </h5>
          <Button
            onClick={() => {
              navigate("/cart");
              window.scrollTo(0, 0);
            }}
            variant="contained"
          >
            Checkout
          </Button>
        </div>
      </section>
    </Box>
  );

  return (
    <main className="home__page">
      {/* THIS CONDITIONALLY RENDERS THE CART ICON IF ITEMS IN CART */}
      {order.length > 0 ? (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            right: 16,
            zIndex: 1000,
            "& > :not(style)": {
              m: 1,
            },
            "@media (max-width: 1000px)": {
              top: "auto",
              bottom: 5,
            },
          }}
        >
          <Fab
            onClick={() => {
              setOpenCartDrawer(true);
            }}
            color="primary"
            aria-label="add"
            sx={{
              backgroundColor: "#FF4840",
              "&:hover": {
                backgroundColor: "#226879",
              },
            }}
          >
            <p style={{ fontWeight: "500" }}>
              {order.reduce((a, b) => a + b.qty, 0)}
            </p>
            <ShoppingCartIcon />
          </Fab>
        </Box>
      ) : null}

      {/* THIS DRAWER IS THE SIDE CART DRAWER */}
      <Drawer
        open={openCartDrawer}
        onClose={() => setOpenCartDrawer(false)}
        anchor="right"
      >
        {DrawerList}
      </Drawer>

      {/* //!HOMEPAGE V2 */}
      <section className="home__hero">
        <h1>THE SCOTTISH BUSINESS CONFERENCE</h1>
        <section className="event__details">
          <div className="detail">
            <LocationOnIcon className="icon" />
            <p>DoubleTree by Hilton on Cambridge Street, Glasgow</p>
          </div>
          <div className="detail">
            <CalendarMonthIcon className="icon" />
            <p>Dates for 2027 coming soon</p>
          </div>
        </section>
        <h2>
          Three Days to Discover What’s Actually Working in Business Right Now 
        </h2>
        <p>
          Learn from business owners who have built and scaled seven and
          eight-figure companies, and leave with clear actions you can use to
          grow your own. 
        </p>
        <section className="video__sect">
          <aside className="text--area">
            <h3>
              Hear first hand what’s working for them right now, the challenges
              they’ve overcome, and{" "}
              <span>the actions that keep their businesses growing</span> in any
              market. 
            </h3>
            <div className="herobtn">
              {/* <button className="hero--btn" onClick={scrollTo}>
                Join The Waiting List
              </button> */}
            </div>
          </aside>
          <section className="video_container" ref={containerRef}>
            <ReactPlayer
              ref={playerRef}
              url="https://vimeo.com/1082206047/91e4602cb5?share=copy"
              width="100%"
              height="100%"
              className="iframe"
              controls
              playing={isPlaying}
              playsInline
              muted
              preload="auto"
            />
          </section>
        </section>
      </section>
      <section className="why">
        {/* <img
          src={coneimg}
          alt="game cone"
          className="cone"
          id="cone1"
          onClick={() => handleCone(1, "cone1")}
        /> */}
        <section className="actionable">
          <h4>
            If you’re using sales and marketing strategies from six months ago,{" "}
            <span>you’re already behind.</span> 
          </h4>
        </section>
        <h3>Why Attend SBC 2025 </h3>
        <section className="why__row">
          <aside className="why--text">
            <p>
              The business world is moving fast. If you’re using sales and
              marketing strategies from six months ago, you’re already behind,
              and what worked last year could be costing you customers today. 
            </p>
            <p>
              At SBC 2025, you’ll get the latest sales, marketing, and growth
              tactics from multi-millionaire entrepreneurs who have built
              thriving companies by staying ahead and implementing what works
              now. {" "}
            </p>
          </aside>
          <img src={people} alt="attendees" />
        </section>
        <section className="why__row">
          <img src={speakers} alt="speakers" className="speak--img" />

          <aside className="why--text text--left">
            <p>
              Over three days, you’ll learn how they’re winning today and
              positioning for 2026, leaving with a clear plan to stay ahead,
              grow faster, and lead your market. {" "}
            </p>
            <h4>Don’t be left behind</h4>
            {/* <button className="cta-btn" onClick={scrollTo}>
              Join The Waiting List
            </button> */}
          </aside>
        </section>
      </section>
      {/* <section className="micro_sponsors">
        <h2>Our Sponsors</h2>
        <section className="sponsors">
          <img className="pmw" src={pmw} alt="Paul McFadden Wealth" />
          <img className="moah" src={Moah} alt="MOAH Media" />
          <img className="satinder" src={Sat} alt="Satinder Panesar" />
          <img className="detailing" src={det} alt="The Detailing Company" />
        </section>
      </section> */}
      <section className="who">
        <h2>
          If you want to grow your business and stay ahead, you’ll be there. 
        </h2>
        <section className="who__row">
          <aside className="who--text">
            <h3>Who Should Attend </h3>
            <section className="text--row">
              <CheckCircleIcon className="icon" />
              <p>You’re ready to take your business to the next level. </p>
            </section>
            <section className="text--row">
              <CheckCircleIcon className="icon" />
              <p>
                You want sales, marketing, and growth tactics that work{" "}
                <span className="colour--text"> right now.</span>  
              </p>
            </section>
            <section className="text--row">
              <CheckCircleIcon className="icon" />
              <p>
                You don’t want competitors getting ahead while the market
                changes fast.  
              </p>
            </section>
            <section className="text--row">
              <CheckCircleIcon className="icon" />
              <p>
                You want to meet other business owners, leaders, and people you
                can work with. 
              </p>
            </section>
            <section className="text--row">
              <CheckCircleIcon className="icon" />
              <p>
                You’re keen to learn from people who’ve already done what you
                want to do. 
              </p>
            </section>
          </aside>
          <img src={attendeesSq} alt="networking" />
        </section>
        <h3>If that sounds like you, grab your ticket and join us. </h3>
        {/* <img
          src={coneimg}
          alt="cone"
          className="cone3"
          id="cone3"
          onClick={() => handleCone(3, "cone3")}
        /> */}
        {/* <button className="cta-btn" onClick={scrollTo}>
          Join The Waiting List
        </button> */}
      </section>
      <SpeakersHP handleCone={handleCone} />
      {/* <Tickets tickets={tickets} /> */}
      {/* <h2>Conference is under way</h2> */}
      <section className="leave">
        <h2>You’ll Leave With:</h2>
        <section className="number__row">
          <h3>1</h3>
          <p>
            Clear, actionable ways to grow sales and profits that are working in
            business right now.
          </p>
        </section>
        <section className="number__row">
          <h3>2</h3>
          <p>
            A step-by-step process to build a business that runs smoothly, with
            or without you.
          </p>
        </section>
        <section className="number__row">
          <h3>3</h3>
          <p>
            Marketing approaches that are delivering results for top-performing
            businesses today.
          </p>
        </section>
        <section className="number__row">
          <h3>4</h3>
          <p>
            Simple ways to use AI to save time, reduce costs, increase
            efficiency, and boost profits.
          </p>
        </section>
        <section className="number__row">
          <h3>5</h3>
          <p>
            Insights from entrepreneurs with multi-million-pound track records,
            and how to apply them to your own business.
          </p>
        </section>
      </section>
      <Testimonials />
      <FAQ handleCone={handleCone} />
      <Modal open={openDiscountModal}>
        <DiscountWheel close={setOpenDiscountModal} />
      </Modal>
      <Modal open={openExitModal} onClose={() => setOpenExitModal(false)}>
        <ExitModal setOpenExitModal={setOpenExitModal} scrollTo={scrollTo} />
      </Modal>
    </main>
  );
}
